import Cereali from "./img/Cereali";
import Crostacei from "./img/Crostacei";
import Uova from "./img/Uova";
import Pesce from "./img/Pesce";
import Arachidi from "./img/Arachidi";
import Soia from "./img/Soia";
import Latte from "./img/Latte";
import FruttaGuscio from "./img/FruttaGuscio";
import Sedano from "./img/Sedano";
import Senape from "./img/Senape";
import SemiSesamo from "./img/SemiSesamo";
import AnidrideSolforosaSolfiti from "./img/AnidrideSolforosaSolfiti";
import Lupini from "./img/Lupini";
import Molluschi from "./img/Molluschi";
import { useContext, useState } from "react";
import { AppContext } from "../../App";

export default function Allergens({ allergens, color = "red", backgroundColor = "pink" }) {
	return (
		<>
			{allergens.map((allergen, i) => (
				<Allergen
					key={i}
					allergen={allergen}
					color={color}
					backgroundColor={backgroundColor}
				/>
			))}
		</>
	);
}

function Allergen({ allergen, color, backgroundColor }) {
	const { lang } = useContext(AppContext);
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const label = getLabel(allergen);

	function getLabel(allergen) {
		if (!allergen) return "";
		if (allergen.translations?.[lang]?.name) return allergen.translations[lang].name;
		if (typeof allergen.translations?.[lang] === "string" && allergen.translations[lang])
			return allergen.translations[lang];
		if (allergen.name) return allergen.name;
		if (typeof allergen.translations === "string") return allergen.translations;
		if (allergen.translations?.it?.name) return allergen.translations.it.name;
		if (allergen.translations?.it) return allergen.translations.it;
		return "";
	}

	return (
		<div
			className={`allergen-item${tooltipOpen ? " open" : ""}`}
			style={{ backgroundColor: backgroundColor, position: "relative" }}
			title={label}
			aria-label={label}
			onMouseEnter={() => setTooltipOpen(true)}
			onMouseLeave={() => setTooltipOpen(false)}
			onClick={() => setTooltipOpen((prev) => !prev)}
		>
			{allergen.id == 1 && <Cereali color={color} />}
			{allergen.id == 2 && <Crostacei color={color} />}
			{allergen.id == 3 && <Uova color={color} />}
			{allergen.id == 4 && <Pesce color={color} />}
			{allergen.id == 5 && <Arachidi color={color} />}
			{allergen.id == 6 && <Soia color={color} />}
			{allergen.id == 7 && <Latte color={color} />}
			{allergen.id == 8 && <FruttaGuscio color={color} />}
			{allergen.id == 9 && <Sedano color={color} />}
			{allergen.id == 10 && <Senape color={color} />}
			{allergen.id == 11 && <SemiSesamo color={color} />}
			{allergen.id == 12 && <AnidrideSolforosaSolfiti color={color} />}
			{allergen.id == 13 && <Lupini color={color} />}
			{allergen.id == 14 && <Molluschi color={color} />}
			<div className="tooltip">
				{label}
			</div>
		</div>
	);
}
